import React from 'react';
import { useSelector } from 'react-redux';

import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  category: '',
  name: '',
  note: ''
};

export const FormInput = ({ product, loading, onInputChange }) => {
  const StateForm = useSelector((state) => state?.Form);

  const [
    { barcode, category, name, note },
    setState,
  ] = React.useState(initialState);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  React.useEffect(() => {
    const input = {
      barcode,
      category,
      name,
      note
    };

    onInputChange(input);
  }, [barcode, category, name, note]);

  React.useEffect(() => {
    if (!product) return;

    setState((prevState) => ({
      ...prevState,
      barcode: product?.barcode,
      category: product?.category,
      name: product?.name,
      note: product?.note,
    }));
  }, [product]);

  return (
    <div className="mt-3">
      {loading ? (
        <div className="row border-bottom">
          {dummy?.map((d, i) => (
            <div className="col-md-4" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      ) : (
        <div className="mt-3">
          <div className="fw-semibold py-2 fs-6">Informasi Product</div>
            <div className="py-3">
              <Form.Input
                required
                label="Nama"
                type="text"
                value={name}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    name: e.target.value,
                  }))
                }
                error={StateForm?.errors?.name}
              />

              <Form.Input
                label="Kategori"
                required
                type="text"
                value={category}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    category: e.target.value,
                  }))
                }
                error={StateForm?.errors?.category}
              />

              <Form.Textbox
                label="Catatan"
                type="text"
                value={note}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    note: e.target.value,
                  }))
                }
                error={StateForm?.errors?.note}
              />
            </div>
        </div>
      )}
    </div>
  );
};
